 

// Poll for user token validation every 10 minutes, will cause rerender
export const USER_ACCESS_POLL_INTERVAL = 600000;
export const TBT_ACKNOWLEDGED_TEXT =
  'I understand that, by signing this Toolbox Topic, I am agreeing/confirming that I have received training on the stated topic, that I fully understand, and that I will therefore be held accountable for the implementation of this information.';
export const ACKNOWLEDGED_TEXT = 'Are you sure you want to complete this item?';

export const INSTANCE_ID_ZF = 7;
